export function toPercent(value?: number): string | undefined {
  if (typeof value === "undefined") return undefined;

  return `${value}%`;
}
